import {IdColorMapFn} from '../declarations'
import {useColorContext} from '../providers/ColorProvider'

export const useCsColorFn = (): IdColorMapFn => useColorContext().getCsColor

export const useFlColorFn = (): IdColorMapFn => useColorContext().getFlColor
